import * as Sentry from "@sentry/react";
import { useImpersonationSessionsDestroyMutation } from "~/store/api";

interface UseStopImpersonation {
  handleStopImpersonation: () => Promise<void>;
  isLoading: boolean;
}

interface StopImpersonationResponse {
  redirect_to: string;
}


export const useStopImpersonation = (): UseStopImpersonation => {
  const [apiImpersonationSessionsDestroy, { isLoading }] =
    useImpersonationSessionsDestroyMutation();
  const handleStopImpersonation = async () => {
    try {
      const response =
        (await apiImpersonationSessionsDestroy().unwrap()) as StopImpersonationResponse;
      // Redirect to the URL provided by the backend (Avo resource page)
      window.location.href = response.redirect_to;
    } catch (e: unknown) {
      console.log("error stopping impersonation:", e);
      Sentry.captureException(e);
    }
  };

  return { handleStopImpersonation, isLoading };
};
